<div class="search-div">
  <mat-form-field class="search-form-field" floatLabel="never">
    <input
      matInput
      [(ngModel)]="searchKey"
      placeholder="Buscar..."
      autocomplete="off"
      (keyup)="applyFilter()"
    />
    <button
      mat-button
      matSuffix
      mat-icon-button
      aria-label="Clear"
      *ngIf="searchKey"
      (click)="onSearchClear()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>
<div class="row my-2">
  <div class="card col-md-4 offset-md-1 text-center">
    <div class="card-header bg-success text-white">
      <div class="card-title">EMPRESA MAS VENTAS</div>
    </div>
    <div class="card-body">
      <h1>$ {{ masVenta }}</h1>
    </div>
  </div>
  <div class="card offset-md-2 col-md-4 offset-md-1 text-center">
    <div class="card-header bg-dark text-white">
      <div class="card-title">MES MAS VENTAS</div>
    </div>
    <div class="card-body">
      <h1>
        {{ bestMonthSeller + " " }} <i class="fa fa-shopping-bag"></i
        >{{ " " + bestMonthCount }}
      </h1>
    </div>
  </div>
</div>
<!--DESKTOP-->

<div
  class="mat-elevation-z8 animate fadeIn tablaSales"
  *ngIf="windowSize.x > 600"
>
  <mat-table [dataSource]="listData" matSort>
    <ng-container matColumnDef="nombre">
      <mat-header-cell *matHeaderCellDef mat-sort-header
        >Nombre</mat-header-cell
      >
      <mat-cell *matCellDef="let element">
        {{ element.nombre }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="monto">
      <mat-header-cell *matHeaderCellDef mat-sort-header
        >Total de Ventas</mat-header-cell
      >
      <mat-cell *matCellDef="let element"
        ><i class="fa fa-usd px-1"></i>: {{ element.monto }} |
        <i class="fa fa-shopping-bag px-1"></i>: {{ element.ventas }}</mat-cell
      >
    </ng-container>
    <ng-container matColumnDef="comision">
      <mat-header-cell *matHeaderCellDef mat-sort-header
        >Comisión</mat-header-cell
      >
      <mat-cell *matCellDef="let element">{{ element.comision }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let row">
        <a [routerLink]="[row.link]">
          <button mat-icon-button color="warn" (click)="onView(row)">
            <mat-icon>remove_red_eye</mat-icon>
          </button></a
        >
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="loading">
      <mat-footer-cell *matFooterCellDef colspan="6">
        Loading data...
      </mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="noData">
      <mat-footer-cell *matFooterCellDef colspan="6">
        No data.
      </mat-footer-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    <mat-footer-row
      *matFooterRowDef="['loading']"
      [ngClass]="{ hide: listData != null }"
    ></mat-footer-row>
    <mat-footer-row
      *matFooterRowDef="['noData']"
      [ngClass]="{ hide: !(listData != null && listData.data.length == 0) }"
    ></mat-footer-row>
  </mat-table>
  <mat-paginator
    [pageSizeOptions]="[5, 1, 25, 100]"
    [pageSize]="5"
    showFirstLastButtons
  ></mat-paginator>
</div>

<!--MOBILE-->

<div
  class="mat-elevation-z8 animate fadeIn tablaMovilSales"
  *ngIf="windowSize.x < 600"
>
  <mat-table [dataSource]="listData" matSort>
    <ng-container matColumnDef="information" style="width: 70%">
      <mat-header-cell *matHeaderCellDef mat-sort-header
        ><i class="fa fa-info text-danger pr-2"></i> Información
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index">
        <div class="row">
          <h4 class="d-flex justify-content-between align-items-center mb-3">
            <span class="badge badge-secondary badge-pill">{{
              i + 1 + " " + element.nombre
            }}</span>
          </h4>

          <div>
            <div class="row text-center">
              <div class="col-md-12 my-2">
                <ul>
                  <li>
                    <small class="text-muted"
                      ><i class="fa fa-usd pr-1"></i>: {{ element.monto }} |
                      <i class="fa fa-shopping-bag pr-1"></i>:
                      {{ element.ventas }}</small
                    >
                  </li>
                  <li>
                    <small class="text-muted"
                      >Comisión: {{ element.comision }}</small
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions" style="width: 30%">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let row">
        <a [routerLink]="[row.link]">
          <button mat-icon-button color="warn" (click)="onView(row)">
            <mat-icon>remove_red_eye</mat-icon>
          </button></a
        >
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="loading">
      <mat-footer-cell *matFooterCellDef colspan="6">
        Loading data...
      </mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="noData">
      <mat-footer-cell *matFooterCellDef colspan="6">
        No data.
      </mat-footer-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedMobileColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedMobileColumns"></mat-row>
    <mat-footer-row
      *matFooterRowDef="['loading']"
      [ngClass]="{ hide: listData != null }"
    ></mat-footer-row>
    <mat-footer-row
      *matFooterRowDef="['noData']"
      [ngClass]="{ hide: !(listData != null && listData.data.length == 0) }"
    ></mat-footer-row>
  </mat-table>
  <mat-paginator
    [pageSizeOptions]="[5, 1, 25, 100]"
    [pageSize]="5"
    showFirstLastButtons
  ></mat-paginator>
</div>
